import React, { useEffect, useState } from "react";
import { fetchWorkingDaysData } from "../Api/UserAttendance"; // expects an API that returns an array of working days
import { fetchCompnayCodesById } from "../Api/InvoiceApi"; // expects an API that returns company codes for an org
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { Button } from "react-bootstrap";
// PayrollScreen: dropdowns for Working Days (shows workingMonth-workingYear) and Company Code
// A button "Calculate Payroll" which will POST the payload to Base_URL/SalaryProcess/CalculatePayroll

export default function PayrollScreen() {
  const { user } = useAuth();
  const navigate=useNavigate();
  const [formData, setFormData] = useState({
    companyCode: "",
    workingDaysId: "",
  });

  const [dropdownData, setDropdownData] = useState({
    companyCodes: [],
    workingDays: [],
  });

  const [loading, setLoading] = useState({
    companyCodes: true,
    workingDays: true,
  });

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const[payroll,setPayroll]=useState([]);
  useEffect(() => {
    // fetch company codes and working days when component mounts
    const orgId = user?.organisationId;
    async function loadCompanyCodes() {
      setLoading((s) => ({ ...s, companyCodes: true }));
      try {
        const res = await fetchCompnayCodesById(orgId);
        setDropdownData((d) => ({ ...d, companyCodes: res || [] }));
      } catch (err) {
        console.error("Failed to load company codes:", err);
        setError((e) => e || "Failed to load company codes");
      } finally {
        setLoading((s) => ({ ...s, companyCodes: false }));
      }
    }

    async function loadWorkingDays() {
      setLoading((s) => ({ ...s, workingDays: true }));
      try {
        const res = await (orgId ? fetchWorkingDaysData(orgId) : fetchWorkingDaysData());
        setDropdownData((d) => ({ ...d, workingDays: res || [] }));
      } catch (err) {
        console.error("Failed to load working days:", err);
        setError((e) => e || "Failed to load working days");
      } finally {
        setLoading((s) => ({ ...s, workingDays: false }));
      }
    }
    async function loadPayroll()
    {
      try{
        const res=await axios.get(`${Base_URL}/SalaryProcess/GetAllWorkingDays/id?id=${orgId}`)
        setPayroll(res.data);
      }
      catch(error)
      {
        console.log(error);
      }
    }
    loadCompanyCodes();
    loadWorkingDays();
    loadPayroll();
  }, [user]);

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((f) => ({ ...f, [name]: value }));
  }

  async function calculatePayroll() {
  setError(null);
  setSuccessMsg("");

  const payload = {
    organisationId: user?.organisationId ?? null,
    userId: user?.userId ?? null,
    companyCode: formData.companyCode,
    workingDaysId: formData.workingDaysId 
  };

  console.log("Calculate Payroll payload:", payload);

  try {
    setSubmitting(true);

    const resp = await axios.post(
      `${Base_URL}/SalaryProcess/CalculatePayroll`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Calculate Payroll response:", resp.data);
    
    toast.success("Payroll Calculated Successfully"); 
    navigate(`/viewPayroll/${payload.workingDaysId}`)// as requested  
    setSuccessMsg("Payroll calculation started successfully.");
    
  } catch (err) {
    console.error("Failed to calculate payroll:", err);

    const message =
      err?.response?.data ||
      err?.message ||
      "Failed to calculate payroll";

    toast.error(message);
    setError(message);
  } finally {
    setSubmitting(false);
  }
}

  return (
    <div className="max-w-3xl mx-auto p-4">
      <h2 className="text-2xl font-semibold mb-4">Payroll Calculation</h2>

      {error && (
        <div className="mb-4 text-red-600">Error: {error}</div>
      )}

      {successMsg && (
        <div className="mb-4 text-green-600">{successMsg}</div>
      )}

      <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); calculatePayroll(); }}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="companyCode" className="block mb-1">Company</label>
            <select
              className="form-select w-full p-2 border rounded"
              id="companyCode"
              name="companyCode"
              value={formData.companyCode}
              onChange={handleChange}
              required
              disabled={loading.companyCodes || submitting}
            >
              <option value="">Select Company</option>
              {dropdownData.companyCodes.map((company) => (
                <option key={company.companyCode} value={company.companyCode}>
                  {company.companyCode} - {company.name}
                </option>
              ))}
            </select>
            {loading.companyCodes && <p className="text-sm mt-1">Loading companies...</p>}
          </div>

          <div>
            <label htmlFor="workingDaysId" className="block mb-1">Working Month</label>
            <select
              className="form-select w-full p-2 border rounded"
              id="workingDaysId"
              name="workingDaysId"
              value={formData.workingDaysId}
              onChange={handleChange}
              required
              disabled={loading.workingDays || submitting}
            >
              <option value="">Select Working Month</option>
              {dropdownData.workingDays.map((item) => (
                <option key={item.workingDaysId} value={item.workingDaysId}>
                  {item.workingMonth}-{item.workingYear}
                </option>
              ))}
            </select>
            {loading.workingDays && <p className="text-sm mt-1">Loading working days...</p>}
          </div>
        </div>

        <div className="pt-4">
          <button
            type="submit"
            className="px-4 py-2 rounded shadow-sm hover:opacity-95"
            disabled={loading.companyCodes || loading.workingDays || submitting}
          >
            {submitting ? "Calculating..." : "Calculate Payroll"}
          </button>
        </div>
      </form>
        <div className="table-responsive mt-3">
          <h1>Past Executed Payrolls</h1>
      <table className="table table-bordered table-striped text-center">
        <thead className="table-dark">
          <tr>
            <th>Working Days ID</th>
            <th>Calendar Days</th>
            <th>Working Month</th>
            <th>Working Year</th>
            <th>Working Days</th>
            <th style={{maxWidth:"30px"}}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {payroll && payroll.length > 0 ? (
            payroll.map((item) => (
              <tr key={item.workingDaysId}>
                <td>{item.workingDaysId}</td>
                <td>{item.calendarDays}</td>
                <td>{item.workingMonth}</td>
                <td>{item.workingYear}</td>
                <td>{item.workingDays}</td>
                <td style={{maxWidth:"30px"}}>
                 <Button
                  variant="outline-primary"
                  size="lg"
                  title="View Payroll"
                  onClick={()=>navigate(`/viewPostedPayroll/${item.workingDaysId}`)}
                  ><FaEye/></Button>
                    
                
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

    </div>
  );
}
